import { useEffect } from 'react';

import { usePreloadImages } from '@common/hooks';

import { type User } from '@services/UsersService';

import { LikeCardSkeleton } from './components/LikeCardSkeleton';
import styles from './LikeCard.module.scss';

export interface LikeCardProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  profile: User;
  showActions?: boolean;
  likeButton: React.ReactNode;
  dislikeButton: React.ReactNode;
  isLocked?: boolean;
  className?: string;
}

export const LikeCard = ({
  profile,
  showActions = true,
  likeButton,
  dislikeButton,
  isLocked = false,
  className,
  onClick,
  ...props
}: LikeCardProps) => {
  const { preloadImages, imagesPreloaded } = usePreloadImages();

  useEffect(() => {
    preloadImages(profile.photos);
  }, [profile.photos, preloadImages]);

  return (
    <div
      {...props}
      onClick={(event) => {
        if (!isLocked && imagesPreloaded) {
          onClick?.(event);
        }
      }}
      className={`${styles.likeCard} ${className || ''}`}
      data-locked={isLocked}
      data-test-id="like-card-container"
    >
      {imagesPreloaded ? (
        <>
          <img
            src={profile.photos[0]}
            width={136}
            height={204}
            data-test-id="like-card-image"
          />

          {showActions && (
            <div
              className={styles.buttonsContainer}
              data-test-id="like-card-actions"
            >
              {dislikeButton}
              {likeButton}
            </div>
          )}
        </>
      ) : (
        <LikeCardSkeleton />
      )}
    </div>
  );
};
